import React from 'react';
import { formatCurrency } from '../../utils/formatCurrency';

const OrderSummary = ({ cartItems, total }) => {
  return (
    <div className="bg-[#FDFBF7] rounded-3xl p-6 border border-[#E8DFC8] shadow-sm space-y-4">
      <h3 className="text-base font-serif font-bold text-[#4A0E17] border-b border-[#E8DFC8] pb-3">
        Order Summary
      </h3>

      {/* Items list */}
      <div className="space-y-3 max-h-60 overflow-y-auto pr-1">
        {cartItems.map((item) => (
          <div key={item.id} className="flex items-center justify-between text-xs">
            <div className="flex items-center space-x-3">
              <img
                src={item.image}
                alt={item.name}
                className="w-12 h-12 object-cover rounded-xl bg-[#F4EFE6] border border-[#E8DFC8] flex-shrink-0"
              />
              <div>
                <p className="font-serif font-bold text-[#4A0E17] line-clamp-1">{item.name}</p>
                <p className="text-[10px] text-[#7A6B5D] mt-0.5">Qty: {item.quantity}</p>
              </div>
            </div>
            <span className="font-serif font-bold text-[#4A0E17]">
              {formatCurrency(item.price * item.quantity)}
            </span>
          </div>
        ))}
      </div>

      {/* Price Breakdown */}
      <div className="border-t border-[#E8DFC8] pt-3 space-y-2 text-xs">
        <div className="flex justify-between text-[#7A6B5D]">
          <span>Subtotal</span>
          <span className="font-semibold text-[#4A0E17]">{formatCurrency(total)}</span>
        </div>
        <div className="flex justify-between text-[#7A6B5D]">
          <span>Insured Express Shipping</span>
          <span className="font-semibold text-emerald-800">FREE</span>
        </div>
        <div className="flex justify-between text-base font-serif font-bold text-[#4A0E17] border-t border-[#E8DFC8] pt-3">
          <span>Total</span>
          <span className="text-[#4A0E17]">{formatCurrency(total)}</span>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;